function e() {
  return !1;
}
export {
  e as default
};
